import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'
import { Form } from 'util/ui'
import { propFunc } from 'util/functions'
import { passwordRules } from 'util/validation'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import ValidatedField from 'shared/components/ui/ValidatedField'
import themeVars from 'ui_theme/site/globals/site.variables'
import PageHeader from '../PageHeader'
import Button from '../../sharedForm/Button'
import SaveIndicator from '../../sharedForm/SaveIndicator'
import sharedStyles from '../../sharedForm/styles.less'

const Conditions = styled('ul')`
  column-count: 2;
  column-gap: ${themeVars.relative60px};
  padding-left: 0;
`

const Condition = styled('li')`
  opacity: ${props => (props.valid ? 0.25 : 1)};
  transition: opacity ${themeVars.defaultDuration} ${themeVars.defaultEasing};
  list-style: none;
  display: inline-block;
  padding: 0 0 ${props => props.theme.spacing['5']} 0;
  color: ${props => props.theme.color.monochrome.black};
  width: 200px;
  :before {
    font-size: ${themeVars['32px']};
    vertical-align: text-bottom;
    content: '\u2022';
    color: ${props => props.theme.color.primary.positive};
    margin-right: ${themeVars['8px']};
  }
`

class EmailPage extends React.PureComponent {
  state = {
    focusedField: null,
    conditions: {},
  }

  componentWillMount = () => {
    this.props.redirectIfAuthenticated(true)
  }

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    onChange(name, value, null, { validate: true })
    if (name === 'password') {
      this.setState({ conditions: passwordRules(value) })
    }
  }

  handleFocus = name => {
    this.setState({ focusedField: name })
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    if (this.state.focusedField === name) {
      onValidate(name, formFields[name])
    }
    this.setState({ focusedField: null })
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      canSave,
      saving,
      submitForm,
    } = this.props
    const { conditions, focusedField } = this.state
    return (
      <>
        <PageHeader />
        <Form
          size="large"
          className={cn(sharedStyles.form, sharedStyles.formV3)}
        >
          <Form.Field>
            <label htmlFor="emailInput">Your work email address</label>
            <ValidatedField
              placeholder="Email address"
              name="emailInput"
              type="email"
              value={formFields.emailInput}
              errorMessage={
                focusedField !== 'emailInput' && formFieldsErrors.emailInput
              }
              onChange={propFunc(this.handleChange, 'emailInput')}
              onFocus={propFunc(this.handleFocus, 'emailInput')}
              onBlur={propFunc(this.handleBlur, 'emailInput')}
              fieldRefCallback={disableLastPassInputRef}
              autoFocus
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="password">Password</label>
            <ValidatedField
              placeholder="Enter 8 characters or more"
              type="password"
              name="password"
              value={formFields.password}
              onChange={propFunc(this.handleChange, 'password')}
            />
          </Form.Field>
          <Form.Field>
            <Conditions>
              <Condition valid={conditions.lowercase}>
                One lowercase character
              </Condition>
              <Condition valid={conditions.uppercase}>
                One uppercase character
              </Condition>
              <Condition valid={conditions.number}>One number</Condition>
              <Condition valid={conditions.special}>
                One special character
              </Condition>
              <Condition valid={conditions.length}>
                8 characters minimum
              </Condition>
            </Conditions>
          </Form.Field>
          <Button disabled={!canSave} onClick={submitForm}>
            {!saving ? (
              'Continue'
            ) : (
              <SaveIndicator animate>Creating account</SaveIndicator>
            )}
          </Button>
        </Form>
      </>
    )
  }
}

export default EmailPage
